module.exports = __webpack_public_path__ + "static/project-13c-a18749a2333581d6517b44ef9cd10b6e.png";